import { render } from "./CommerceSidebar.vue?vue&type=template&id=7e14d584&ts=true"
import script from "./CommerceSidebar.vue?vue&type=script&lang=ts"
export * from "./CommerceSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__